import axios from 'axios';

const api = axios.create({ baseURL: '/.api/www' });

export default {
  getProductsByIds(pageId, productIds) {
    try {
      return api.get(`/pages/${pageId}/products?id=${productIds}`);
    } catch (e) {
      return new Error(e);
    }
  },
  async postForm(pageId, data) {
    try {
      return await api.post(`/pages/${pageId}/form`, { data });
    } catch (e) {
      throw new Error(e);
    }
  },
  async getMyInfo() {
    try {
      return api.get('/users/myinfo');
    } catch (err) {
      return new Error(err);
    }
  },
};
